<template lang="">
  <div class="square">
      <div class="sq_box">
          <div @transitionend="transtionEnd" id="sq_dom" class="sq" :style="transition">
              <img class="sq_img" src="./square.png"/>
          </div>
          <div @click="onClickLottery" class="sq_lott">

          </div>
      </div>
  </div>
</template>

<script>
import Vue from "vue"

export default Vue.extend({
  props:['prizePos','prizeList','value'],
  data(){
    return {
      animate:false,
      opts:{
          cyclesMin: 5, /* 转动圈数最小值 */
          cyclesMax: 8, /* 转动圈数最大值 */
      },
      squareLength:8,
      transition:'',
      deg:0,
      cycles:0,
      squareDeg:0
    }
  },
  watch:{
    value(){
        if(this.value){
            this.squareDeg = this.computedSquareDeg();
            this.deg = this.computedDeg();
            this.transition = 'transition: all 6s ease 0s;transform: rotate('+this.deg+'deg);'
        }
    }
  },
  methods:{
    transtionEnd(){
        console.log(this.prizePos)
        this.$emit("input",false);
        this.transition = 'transition: none 0s ease 0s;transform: rotate('+this.squareDeg+'deg);';
        /* 动画结束时恢复角度为360度以内 */
        this.deg = this.deg%360;
        this.$emit("success",this.prizeList[this.prizePos]);
    },
    computedCircles(){
        var min = this.opts.cyclesMin;
        var max = this.opts.cyclesMax;
        return Math.ceil(min+Math.random()*(max-min))
    },
    computedDeg(){
        return this.squareDeg+360*this.computedCircles()
    },
    computedSquareDeg(){
        var baseDeg = 360/this.squareLength;
        var min = baseDeg*this.prizePos-baseDeg/2;
        var max = baseDeg*this.prizePos+baseDeg/2;
        //return Math.random()*(max-min)+min
        return this.deg+baseDeg*this.prizePos-this.deg%360
    },
    onClickLottery(){
        if(this.value)return;/* 已经在转的话点击不能起作用 */
        this.$emit("lottery");
    }
  }
})
</script>

<style lang="less" scoped="true">
  @import './index.less';
</style>
